import React from "react";

const MonitoringContext = React.createContext();

export default MonitoringContext;